import { render, staticRenderFns } from "./TerminosCondicionesPage.vue?vue&type=template&id=1244b674&"
import script from "./TerminosCondicionesPage.vue?vue&type=script&lang=js&"
export * from "./TerminosCondicionesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports